import { commonjsGlobal as d } from "../../../../../_virtual/_commonjsHelpers.js";
var M, J;
function Xr() {
  if (J) return M;
  J = 1;
  var _ = 9007199254740991, B = "[object Arguments]", X = "[object Function]", Z = "[object GeneratorFunction]", y = "[object Map]", Q = "[object Object]", C = "[object Promise]", l = "[object Set]", Y = "[object String]", k = "[object WeakMap]", E = "[object DataView]", rr = /[\\^$.*+?()[\]{}|]/g, tr = /^\[object .+?Constructor\]$/, nr = /^(?:0|[1-9]\d*)$/, b = "\\ud800-\\udfff", R = "\\u0300-\\u036f\\ufe20-\\ufe23", P = "\\u20d0-\\u20f0", I = "\\ufe0e\\ufe0f", er = "[" + b + "]", h = "[" + R + P + "]", m = "\\ud83c[\\udffb-\\udfff]", or = "(?:" + h + "|" + m + ")", V = "[^" + b + "]", F = "(?:\\ud83c[\\udde6-\\uddff]){2}", L = "[\\ud800-\\udbff][\\udc00-\\udfff]", $ = "\\u200d", G = or + "?", N = "[" + I + "]?", ir = "(?:" + $ + "(?:" + [V, F, L].join("|") + ")" + N + G + ")*", ar = N + G + ir, ur = "(?:" + [V + h + "?", h, F, L, er].join("|") + ")", cr = RegExp(m + "(?=" + m + ")|" + ur + ar, "g"), sr = RegExp("[" + $ + b + R + P + I + "]"), fr = typeof d == "object" && d && d.Object === Object && d, pr = typeof self == "object" && self && self.Object === Object && self, o = fr || pr || Function("return this")();
  function gr(r, t) {
    for (var n = -1, e = r ? r.length : 0, u = Array(e); ++n < e; )
      u[n] = t(r[n], n, r);
    return u;
  }
  function dr(r) {
    return r.split("");
  }
  function yr(r, t) {
    for (var n = -1, e = Array(r); ++n < r; )
      e[n] = t(n);
    return e;
  }
  function lr(r, t) {
    return gr(t, function(n) {
      return r[n];
    });
  }
  function br(r, t) {
    return r?.[t];
  }
  function hr(r) {
    return sr.test(r);
  }
  function mr(r) {
    var t = !1;
    if (r != null && typeof r.toString != "function")
      try {
        t = !!(r + "");
      } catch {
      }
    return t;
  }
  function Sr(r) {
    for (var t, n = []; !(t = r.next()).done; )
      n.push(t.value);
    return n;
  }
  function jr(r) {
    var t = -1, n = Array(r.size);
    return r.forEach(function(e, u) {
      n[++t] = [u, e];
    }), n;
  }
  function Ar(r, t) {
    return function(n) {
      return r(t(n));
    };
  }
  function Tr(r) {
    var t = -1, n = Array(r.size);
    return r.forEach(function(e) {
      n[++t] = e;
    }), n;
  }
  function Or(r) {
    return hr(r) ? wr(r) : dr(r);
  }
  function wr(r) {
    return r.match(cr) || [];
  }
  var vr = Function.prototype, f = Object.prototype, S = o["__core-js_shared__"], q = (function() {
    var r = /[^.]+$/.exec(S && S.keys && S.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  })(), D = vr.toString, p = f.hasOwnProperty, c = f.toString, xr = RegExp(
    "^" + D.call(p).replace(rr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), K = o.Symbol, j = K ? K.iterator : void 0, Mr = f.propertyIsEnumerable, _r = Ar(Object.keys, Object), A = s(o, "DataView"), T = s(o, "Map"), O = s(o, "Promise"), w = s(o, "Set"), v = s(o, "WeakMap"), Cr = a(A), kr = a(T), Er = a(O), Rr = a(w), Pr = a(v);
  function Ir(r, t) {
    var n = U(r) || Dr(r) ? yr(r.length, String) : [], e = n.length, u = !!e;
    for (var g in r)
      p.call(r, g) && !(u && (g == "length" || Gr(g, e))) && n.push(g);
    return n;
  }
  function Vr(r) {
    return c.call(r);
  }
  function Fr(r) {
    if (!z(r) || Nr(r))
      return !1;
    var t = W(r) || mr(r) ? xr : tr;
    return t.test(a(r));
  }
  function Lr(r) {
    if (!qr(r))
      return _r(r);
    var t = [];
    for (var n in Object(r))
      p.call(r, n) && n != "constructor" && t.push(n);
    return t;
  }
  function $r(r, t) {
    var n = -1, e = r.length;
    for (t || (t = Array(e)); ++n < e; )
      t[n] = r[n];
    return t;
  }
  function s(r, t) {
    var n = br(r, t);
    return Fr(n) ? n : void 0;
  }
  var i = Vr;
  (A && i(new A(new ArrayBuffer(1))) != E || T && i(new T()) != y || O && i(O.resolve()) != C || w && i(new w()) != l || v && i(new v()) != k) && (i = function(r) {
    var t = c.call(r), n = t == Q ? r.constructor : void 0, e = n ? a(n) : void 0;
    if (e)
      switch (e) {
        case Cr:
          return E;
        case kr:
          return y;
        case Er:
          return C;
        case Rr:
          return l;
        case Pr:
          return k;
      }
    return t;
  });
  function Gr(r, t) {
    return t = t ?? _, !!t && (typeof r == "number" || nr.test(r)) && r > -1 && r % 1 == 0 && r < t;
  }
  function Nr(r) {
    return !!q && q in r;
  }
  function qr(r) {
    var t = r && r.constructor, n = typeof t == "function" && t.prototype || f;
    return r === n;
  }
  function a(r) {
    if (r != null) {
      try {
        return D.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  function Dr(r) {
    return Kr(r) && p.call(r, "callee") && (!Mr.call(r, "callee") || c.call(r) == B);
  }
  var U = Array.isArray;
  function x(r) {
    return r != null && Ur(r.length) && !W(r);
  }
  function Kr(r) {
    return H(r) && x(r);
  }
  function W(r) {
    var t = z(r) ? c.call(r) : "";
    return t == X || t == Z;
  }
  function Ur(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= _;
  }
  function z(r) {
    var t = typeof r;
    return !!r && (t == "object" || t == "function");
  }
  function H(r) {
    return !!r && typeof r == "object";
  }
  function Wr(r) {
    return typeof r == "string" || !U(r) && H(r) && c.call(r) == Y;
  }
  function zr(r) {
    if (!r)
      return [];
    if (x(r))
      return Wr(r) ? Or(r) : $r(r);
    if (j && r[j])
      return Sr(r[j]());
    var t = i(r), n = t == y ? jr : t == l ? Tr : Jr;
    return n(r);
  }
  function Hr(r) {
    return x(r) ? Ir(r) : Lr(r);
  }
  function Jr(r) {
    return r ? lr(r, Hr(r)) : [];
  }
  return M = zr, M;
}
export {
  Xr as __require
};
